import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import { IRootState } from 'src/redux/rootReducer';
import './styles.scss';

const View: React.FC<ViewProps> = ({
  children,
  className,
  isRow,
  justify = 'flex-start',
  align = '',
  renderIf = true,
  flexGrow = 0,
  style,
  ...props
}) => {
  if (!renderIf) return null;

  return (
    <div
      className={cn(
        'cmp-view',
        {
          [`cmp-view__justify--${justify}`]: justify,
          [`cmp-view__align--${align}`]: align,
          'cmp-view--row': isRow,
        },
        className,
      )}
      style={{ ...style, flexGrow }}
      {...props}>
      {children}
    </div>
  );
};

export type ViewProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
    isRow?: boolean;
    justify?: 'center' | 'space-between' | 'flex-start' | 'flex-end' | 'space-around' | 'space-evenly';
    align?: 'center' | 'flex-start' | 'flex-end';
    renderIf?: boolean;
    flexGrow?: number;
  };

const mapStateToProps = (state: IRootState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(View);
